import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useUser, hasRole } from '@/app/store/auth'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { Shield, AlertTriangle } from 'lucide-react'

interface AdminRouteProps {
    children: ReactNode
    fallback?: ReactNode
}

export function AdminRoute({ children, fallback }: AdminRouteProps) {
    const user = useUser()
    const isAdmin = hasRole(user, 'admin')

    if (!user) {
        return <Navigate to="/login" replace />
    }

    if (!isAdmin) {
        if (fallback) {
            return <>{fallback}</>
        }

        return (
            <div className="container mx-auto p-6">
                <Alert variant="destructive">
                    <AlertTriangle className="h-4 w-4" />
                    <AlertDescription>
                        <div className="flex items-center space-x-2">
                            <Shield className="h-5 w-5" />
                            <span>Access Denied</span>
                        </div>
                        <p className="mt-2">
                            You don't have permission to access this page. Administrator privileges are required.
                        </p>
                    </AlertDescription>
                </Alert>
            </div>
        )
    }

    return <>{children}</>
}



